// 'use client';

import { createContext } from 'react';

import { darkTheme } from '@/styled/themes/darkTheme';
import { lightTheme } from '@/styled/themes/lightTheme';

interface ThemeContextProps {
  toggleTheme: () => void;
  theme: typeof lightTheme | typeof darkTheme;
}

export const ThemeContext = createContext<ThemeContextProps>({
  toggleTheme: () => {},
  theme: lightTheme
});
